import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgreementComponent } from '@bca-agreement/agreement/agreement.component';
import { ChooseIssuerComponent } from '@bca-agreement/agreement/choose-issuer/choose-issuer.component';
import { SharedModule } from '@bca-shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
        AgreementComponent,
        ChooseIssuerComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    FormsModule,
    TranslateModule.forChild(),
  ],
  exports: [AgreementComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AgreementModule {}
